import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section id="faq" className="bg-background-100/50 py-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              常见问题
            </h2>
            <p className="text-foreground-600 mt-2 text-sm">关于亚洲免费在线平台，你想知道的都在这里</p>
          </div>
          <div className="space-y-3">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 transition-transform text-lg flex-shrink-0 ${
                      openId === item.id ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openId === item.id && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}